"use client";
import { Menu, X } from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState } from "react";
import { Button } from "../ui/button";
import MobileNav from "./MobileNav";

const Navbar = () => {
	const pathname = usePathname();
	const [mobileOpen, setMobileOpen] = useState(false);

	return (
		<div className="flex justify-between items-center w-full">
			<span></span>
			<nav
				className={
					pathname.includes("dashboard")
						? "hidden"
						: "hidden md:flex items-center space-x-6 text-sm font-medium"
				}
			>
				{[
					{ name: "Features", href: "#features" },
					{ name: "How it Works", href: "#how-it-works", soon: true },
					{ name: "Modes", href: "#pricing" },
				].map((link) => (
					<Link
						key={link.name}
						href={link.href}
						className={` text-base ${
							link.soon && "pointer-events-none"
						} relative text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors
                         after:content-[''] after:absolute after:w-0 after:h-[2px] after:left-0 after:-bottom-1 after:bg-gradient-to-r after:from-orange-500 after:to-purple-600 after:transition-all after:duration-300 hover:after:w-full`}
					>
						{link.soon && (
							<small className="absolute font-bold -top-3 right-0 text-[10px] text-green-700">
								soon
							</small>
						)}
						{link.name}
					</Link>
				))}
			</nav>

			<div className="flex items-center gap-x-4">
				<div
					id="auth-navbar-buttons"
					className="flex items-center gap-x-4"
				/>

				<Button
					onClick={() => setMobileOpen(!mobileOpen)}
					className="md:hidden p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition"
				>
					{mobileOpen ? <X /> : <Menu />}
				</Button>
			</div>

			{mobileOpen && <MobileNav setMobileOpen={setMobileOpen} />}
		</div>
	);
};

export default Navbar;
